import InfoBar from "../assets/wrappers/InfoBar"

const StartingInfo = () => {
    return (
        <InfoBar style={{height: 100}}>
            Click the "Add Scoop" button to start creating the icecream of your desires!
        </InfoBar>
    )
}

export default StartingInfo